import { STATUS_NOT_ACTIVE, STATUSES } from '@/config/config'
import formBaseMixin                   from '../../../components/form/form-base-mixin.js'
import year                            from '../../../utils/year'
import { core }                        from '@/api/api-endpoints'
import documentsMixin                  from '@/common/layout/documents/documentsMixin'

export default {
  mixins:   [formBaseMixin, documentsMixin],
  computed: {
    notActive() {
      return STATUS_NOT_ACTIVE
    },
    statuses() {
      return STATUSES
    },
    years() {
      return year.getSpecifiedYearsOptions(2013, 2050, false)
    },
    regionalOperators() {
      return this.$store.getters.readUrlEndpoint(this.getRegionalOperatorEndpoint()).data
    }
  },
  methods:  {
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        if (this.fields.status) {
          this.$set(this.fields, 'status_id', +this.fields.status.id)
        }
        
        this.fields._cadastralCode = this.fields.cadastralCodes && this.fields.cadastralCodes[0]
          ? this.fields.cadastralCodes[0].cadastral_code
          : ''
      }
    },
    prepareFieldsForSend(fields = {}) {
      this.fields.cadastral_code = [this.fields._cadastralCode]
      return fields
    },
    fileUploaded({ id }) {
      this.fields.photo_id = id
    },
    fileRemoved() {
      this.fields.photo_id = null
    },
    uploadUrl() {
      return core.file()
    }
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', { endpoint: methods.getItemEndpoint(route, fromRoute) }))
    }
    
    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint:  methods.getRegionalOperatorEndpoint(),
      fromCache: true
    }))
    
    if (promises.length === 0) {
      return Promise.resolve(1)
    }
    
    return Promise.all(promises)
  }
}

